export default function (gtel, td = 0) {
  // ${DataURL3}
  return `/CheWeb?gtel=${gtel}_${td}`
}
